module.exports = __webpack_public_path__ + "startpage-746fed5a/cover-letter-bg-mobile-0d4a30d64a646a50e4f93df359a537eb.svg";